export class BrowserFeatures {
  private constructor() {}

  // Public

  get hasWorker() {
    return typeof Worker !== 'undefined';
  }

  get hasAtomics() {
    return typeof Atomics !== 'undefined';
  }

  get hasSharedArrayBuffer() {
    return typeof SharedArrayBuffer !== 'undefined';
  }

  get hasWebAssembly() {
    if (this.#webAssembly === undefined) this.#webAssembly = this.#testWebAssembly();
    return this.#webAssembly;
  }

  get hasSharedMemory(): boolean {
    if (this.#sharedMemory === undefined) this.#sharedMemory = this.#testSharedMemorySupport();
    return this.#sharedMemory;
  }

  get hasSimd(): boolean {
    if (this.#simd === undefined) this.#simd = this.#testSIMDSupport();
    return this.#simd;
  }

  get hasWorkersImport(): boolean {
    if (this.#workerImports === undefined) this.#workerImports = this.#testWorkerImportsSupport();
    return this.#workerImports;
  }

  // HACK: fix mobile safari shared memory allocation bug
  get canUseLotsOfSharedMemory(): boolean {
    try {
      new WebAssembly.Memory({
        // Значения из воркера stockfish-17-lite.js
        initial: 2048,
        maximum: 32768,
        shared: true,
      });
      return true;
    } catch {
      return false;
    }
  }

  // Static

  static get instance(): BrowserFeatures {
    if (!this.#instance) {
      this.#instance = new BrowserFeatures();
    }
    return this.#instance;
  }

  // Private

  #webAssembly?: boolean;
  #sharedMemory?: boolean;
  #simd?: boolean;
  #workerImports?: boolean;
  static #instance: BrowserFeatures;

  #testWebAssembly() {
    if (typeof WebAssembly === 'undefined') return false;
    return WebAssembly.validate(Uint8Array.from([0, 97, 115, 109, 1, 0, 0, 0]));
  }

  #testSharedMemorySupport() {
    if (!this.hasAtomics || !this.hasSharedArrayBuffer || !this.hasWebAssembly) {
      return false;
    }

    try {
      const { buffer } = new WebAssembly.Memory({
        shared: true,
        initial: 1,
        maximum: 2,
      });
      window.postMessage(buffer, '*');
      return buffer instanceof SharedArrayBuffer;
    } catch {
      return false;
    }
  }

  #testSIMDSupport() {
    return WebAssembly.validate(
      Uint8Array.from([
        0, 97, 115, 109, 1, 0, 0, 0, 1, 12, 2, 96, 2, 123, 123, 1, 123, 96, 1, 123, 1, 123, 3, 3, 2,
        0, 1, 7, 9, 2, 1, 97, 0, 0, 1, 98, 0, 1, 10, 19, 2, 9, 0, 32, 0, 32, 1, 253, 186, 1, 11, 7,
        0, 32, 0, 253, 253, 1, 11,
      ]),
    );
  }

  #testWorkerImportsSupport() {
    try {
      new Worker(
        URL.createObjectURL(
          new Blob(["import('data:text/javascript,export default {}')"], {
            type: 'application/javascript',
          }),
        ),
      ).terminate();
      return true;
    } catch {
      return false;
    }
  }
}
